<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1713Hzx/cover.jpg?1700571411016" alt="This image is the cover for the book Lady of Mallow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady of Mallow
      </h1>
      <p class="bookDescription body article font2">
        <b>Hailed by the <i>New York Times</i> as a novel that “should easily satisfy the same readers who made a bestseller out of Victoria Holt’s <i>Mistress of Mellyn</i>,” Dorothy Eden’s masterwork of Gothic romance presents the story of a governess who falls dangerously in love with the mysterious heir to a manor house</b><br/>It’s a precarious charade with the highest stakes imaginable. Sarah Mildmay’s entire future rests on exposing the current lord of Mallow as the great pretender he is. Blane Mallow, presumed dead after years at sea, has suddenly returned to claim his title—and the magnificent English estate that rightfully belongs to Sarah’s fiancé, Blane’s cousin Ambrose.<br/><br/>Determined to unmask the imposter, Sarah talks her way into a position as governess to Blane’s son, Titus. At Mallow Hall, she meets Blane’s suspicious wife, Amalie, and the formidable Lady Malvina. But the deception Sarah suspects reveals itself to be far more malevolent and far-reaching than she imagined. As she fights her growing attraction to Blane, the arrival of a stranger sets in motion a series of events that will have deadly consequences. Desperate to protect Titus, Sarah moves closer to a shattering truth: The man she loves may be a cold-blooded murderer . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Eden
      </h2>
      
      <p class="authorDescription body article">Dorothy Eden (1912&ndash;1982) was the internationally acclaimed author of more than forty bestselling Gothic, romantic suspense, and historical novels. Born in New Zealand, where she attended school and worked as a legal secretary, she moved to London in 1954 and continued to write prolifically. Eden&rsquo;s novels are known for their suspenseful, spellbinding plots, finely drawn characters, authentic historical detail, and often a hint of spookiness.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1493dd73